import { c as _c } from "react/compiler-runtime";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
interface ActionButtonProps {
  readonly onClicked: () => void;
  readonly children: React.ReactNode;
  readonly size?: "default" | "sm" | undefined;
  readonly disabled?: boolean | undefined;
  readonly loading?: boolean | undefined;
}
export default function ActionButton(t0) {
  const $ = _c(8);
  const {
    onClicked,
    children,
    size: t1,
    disabled: t2,
    loading: t3
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const disabled = t2 === undefined ? false : t2;
  const loading = t3 === undefined ? false : t3;
  const sizeClasses = size === "sm" ? "tw-px-2.5 tw-py-1.5 tw-text-xs" : "tw-px-3.5 tw-py-2.5 tw-text-sm ";
  const t4 = disabled || loading;
  const t5 = disabled || loading ? undefined : onClicked;
  const t6 = `tw-rounded-md tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-ring-1 tw-ring-primary-500 ${sizeClasses} tw-flex tw-items-center tw-justify-center tw-gap-x-1.5 tw-font-semibold tw-text-white tw-shadow-sm tw-transition tw-duration-300 tw-ease-out hover:tw-border-primary-600 hover:tw-bg-primary-600 hover:tw-ring-primary-600 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-600 ${disabled || loading ? "tw-cursor-not-allowed tw-opacity-50" : ""}`;
  let t7;
  if ($[0] !== loading) {
    t7 = loading && <CircleLoader />;
    $[0] = loading;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== children || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = <button type="button" disabled={t4} onClick={t5} className={t6}>{t7}{children}</button>;
    $[2] = children;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
}